/**
 * AutoCount - Suppliers List Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

const suppliers = [
  { code: "AZD-001", name: "AutoZone Distribution", contact: "John Smith", email: "orders@autozone.com", phone: "(800) 555-0101", status: "Active" },
  { code: "NAP-001", name: "NAPA Auto Parts", contact: "Jane Doe", email: "orders@napa.com", phone: "(800) 555-0102", status: "Active" },
  { code: "ORL-001", name: "O'Reilly Auto Parts", contact: "Mike Johnson", email: "orders@oreilly.com", phone: "(800) 555-0103", status: "Active" },
  { code: "RAT-001", name: "RockAuto", contact: "Sarah Williams", email: "orders@rockauto.com", phone: "(866) 555-0104", status: "Active" },
  { code: "AAP-001", name: "Advance Auto Parts", contact: "Tom Brown", email: "orders@advance.com", phone: "(800) 555-0105", status: "Inactive" },
];

function SuppliersList(): JSX.Element {
  const navigate = useNavigate();
  const columns = [
    { Header: "Code", accessor: "code", width: "10%" },
    { Header: "Name", accessor: "name", width: "25%" },
    { Header: "Contact", accessor: "contact", width: "15%" },
    { Header: "Email", accessor: "email", width: "20%" },
    { Header: "Phone", accessor: "phone", width: "15%" },
    { Header: "Status", accessor: "status", width: "10%" },
  ];

  const rows = suppliers.map((s) => ({
    ...s,
    status: (
      <MDTypography
        variant="caption"
        color={s.status === "Active" ? "success" : "secondary"}
        fontWeight="medium"
      >
        {s.status}
      </MDTypography>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Suppliers
                </MDTypography>
                <MDButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={() => navigate("/suppliers/add")}
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;Add Supplier
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={{ defaultValue: 10, entries: [5, 10, 25, 50] }}
                  showTotalEntries={true}
                  canSearch={true}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SuppliersList;
